// libraries.
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// selectors.
import { getIsHoveredSidebar } from '@shared/Sidebar/store/slices/sidebar-slice';
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';

// domains.
import { CountryCode } from '@domains/country';

// components.
import { ButtonLogo, Sidebar, ButtonSidebar } from '@shared';
import { DropdownCountry } from '@domains/user/components/DropdownCountry/DropdownCountry';
import { LogOutButton } from '@domains/user/components/LogOutButton/LogOutButton';

// assets.
import { IconProgress, IconCentral, IconPriceTag } from '@assets/icons';

export const SidebarOrchestrator = () => {
  const navigate = useNavigate();
  const isHoveredSidebar = useSelector(getIsHoveredSidebar);
  const country = useSelector(getCountry);

  const handleNavigateToListOpc = () => {
    navigate('/orchestrator-pricing-committee/list-opc');
  };

  const handleNavigateToAnalytics = () => {
    navigate('/orchestrator-pricing-committee/analytics-opc');
  };

  const handleNavigateToMaxPrice = () => {
    navigate('/orchestrator-pricing-committee/max-price-opc');
  };

  return (
    <Sidebar
      upperButtons={
        <>
          <ButtonLogo />
          <ButtonSidebar
            onClick={handleNavigateToListOpc}
            icon={<IconCentral width="24" height="24" fill="white" />}
            text="La Central"
          />
          <ButtonSidebar
            onClick={handleNavigateToAnalytics}
            icon={<IconProgress width="24" height="24" fill="white" />}
            text="Analiticos"
          />
          {country === CountryCode.MX && (
            <ButtonSidebar
              onClick={handleNavigateToMaxPrice}
              icon={<IconPriceTag width="24" height="24" fill="white" />}
              text="Precio Máximo"
            />
          )}
        </>
      }
      lowerButtons={
        <>
          <DropdownCountry isHoveredSidebar={isHoveredSidebar} />
          <LogOutButton />
        </>
      }
    />
  );
};
